import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import httpServices from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import { Link } from "react-router-dom";

function GetGift({ marketerID, isGetGift }) {
  const [content, setContent] = useState(<></>);
  const [canGetGift, setCanGetGift] = useState(false);
  const [message, setMessage] = useState();
  const [gift, setGift] = useState();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  useEffect(() => {
    getContent();
  }, []);

  useEffect(() => {
    if (!canGetGift) {
      return;
    }
    setStatusGiftToUser();
  }, [canGetGift]);

  useEffect(() => {
    if (!gift) {
      return;
    }
    setContent(generateTagsUseGift());
  }, [gift]);

  const showUserDoseNotHavePayment = () => {
    return (
      <div class="d-flex flex-column flex-md-row">
        <div class="text-center text-md-right">
          <img
            src="/assets/img/do-not-have-invoices.svg"
            className="img-fluid w-75"
          />
        </div>
        <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p>برای استفاده از هدیه ویژه باید حداقل یک پرداخت انجام بدید.</p>
          <p>شما تاکنون هیچ پرداختی نداشته اید.</p>
          <span>
            <Link to="/finance/charge" className="btn btn-success ">
              <span className="pl-2">
                <i className="fa fa-plus"></i>
              </span>
              <span>پرداخت</span>
            </Link>
          </span>
        </div>
      </div>
    );
  };

  const setStatusGiftToUser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestSetStatusGiftToUser =
      await sendRequestSetStatusGiftToUser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestSetStatusGiftToUser) {
      return;
    }

    setGift(resultSendRequestSetStatusGiftToUser);
  };

  const sendRequestSetStatusGiftToUser = async () => {
    let result;
    let headersRequest = getHeaderForRequest();
    try {
      result = await httpServices.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/gift/check-user-can-use-gift",
        headersRequest
      );
    } catch (error) {
      if (error.response.data.message.error_code == 422) {
        setContent(showUserDoseNotHavePayment());
        return false;
      }
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return result.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getContent = () => {
    switch (true) {
      case !marketerID:
        setContent(
          <p className="alert alert-danger">
            شما امکان دریافت هدیه ویژه را ندارید چون توسط بازاریاب ثبت نام نشدید
          </p>
        );
        break;
      case marketerID && isGetGift:
        setContent(
          <p className="alert alert-danger">شما هدیه ویژه را دریافت کردید </p>
        );
        break;
      case marketerID && !isGetGift:
        setCanGetGift(true);
        break;
    }
  };

  const getGift = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetGift = await sendRequestGetGift();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestGetGift) {
      return;
    }

    setMessage({
      type_class: "alert alert-success text-dark",
      text: "دریافت هدیه شما با موفقیت انجام شد و مبلغ هدیه به موجودی شما اضافه شد.",
      class_icon: "fa fa-check-circle text-dark",
    });
    setTimeout(() => {
      window.location.replace("/campaigns/all");
    }, 2000);
  };

  const sendRequestGetGift = async () => {
    let headersRequest = getHeaderForRequest();
    try {
      await httpServices.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/gift/get-user-gift",
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }

    return true;
  };

  const generateTagsUseGift = () => {
    return (
      <div>
        <p>
          اولین مبلغ پرداختی شما بدون احتساب
          <span className="px-2">
            {helpersNumbers.toPersianNum(
              process.env.REACT_APP_TAX_PERCENT_AMOUNT_CHARGE
            )}
          </span>
          درصد مالیات بر ارزش افزوده
          <span className="number-finance px-2">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(gift.amount)
            )}
          </span>
          تومان است
        </p>
        <p>
          بدین ترتیب شما میتوانید از هدیه
          <span className="px-2">
            {helpersNumbers.toPersianNum(gift.gift_percent)}
          </span>
          درصد افزایش اعتبار استفاده کنید.
        </p>
        <p>
          مبلغ هدیه شما
          <span className="number-finance px-2">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(
                (gift.amount * gift.gift_percent) / 100
              )
            )}
          </span>
          تومان می باشد با کلیک بر دکمه زیر هدیه خود را دریافت کنید.
        </p>
        <div>
          <button className="btn btn-success" onClick={getGift}>
            <span className="pl-2">
              <i className="fa fa-gift"></i>
            </span>
            <span>دریافت هدیه</span>
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="all-finance" activeItem="get-gift" />

      <div className="content-wrapper">
        <TitleBar title="دریافت هدیه ویژه" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {messageTag}
              {content}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    marketerID: state.main.marketer_id,
    isGetGift: state.main.is_get_gift,
  };
};

export default connect(mapStateToProps, {})(GetGift);
